import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  checkPhoneNoFieldsCount(e) {
    e.preventDefault();

    const phoneNoFields = document.querySelectorAll('.phone-number-action-link');
    const phoneNoFieldsCount = phoneNoFields.length;

    const pn = this.element.dataset.phoneNumberCount;
    const phoneNumberCount = pn !== undefined ? parseInt(pn, 10) : 9;

    if (phoneNoFieldsCount >= phoneNumberCount) this.addPhoneNoBtn("hide", '#add-new-phone-number-first-manual-entry-phone-number-field');
    if (this.element.dataset.showAddNewBtn) this.addPhoneNoBtn("show", '#add-new-phone-number-first-manual-entry-phone-number-field');
  }

  addPhoneNoBtn(action, selector) {
    const addPhoneNoBtn = document.querySelector(selector);
    action === "hide" ? addPhoneNoBtn.classList.add('vanish') : addPhoneNoBtn.classList.remove('vanish')
  }

  checkBuyerFieldsCount(e) {
    e.preventDefault();

    const buyerFields = document.querySelectorAll('.action-link');
    const buyerFieldsCount = buyerFields.length;

    if (buyerFieldsCount >= 1) this.addPhoneNoBtn("hide", '#add-new-buyer-first-manual-entry-field');
    if (this.element.dataset.showAddNewBtn) this.addPhoneNoBtn("show", '#add-new-buyer-first-manual-entry-field');
  }

  validateAdditionalEmail() {
    const emailField = document.querySelector('#additional_cc_email_field');
    // .filter(Boolean); removes empty strings from the array
    const emails = emailField.value.split(',').map(s => s.trim()).filter(Boolean);

    emails.forEach(email => {
      console.log(email)
      if (!this.validateEmail(email.trim())) {
        super.renderToast(
          "global-flash-msg-container", "Please enter a valid Additional CC Email address.", "danger", false, null, 4500, true
        );
        return;
      }
    });

    const emailsCount = emails.length;

    if (emailsCount > 5) {
      super.renderToast(
        "global-flash-msg-container", "You can only add up to 5 Additional CC Emails.", "danger", false, null, 4500, true
      );
      return;
    }
  }

  validateEmail(email) {
    // Regular expression to validate email address
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Test the email against the regex
    return emailRegex.test(email);
  }
}